module.exports = __webpack_public_path__ + "static/media/37-marco.9397eac7.jpg";